import { REDIRECT_APP } from '@/constants/authentication';

export const getRedirectAppParams = () => {
  const redirectApp = localStorage.getItem(REDIRECT_APP);
  return redirectApp ? `?${REDIRECT_APP}=` + redirectApp : '';
};
